export const footerlinks = [
  {
    text: 'About Us',
    path: '/aboutus',
  },
  {
    text: 'FAQ',
    path: '/',
  },

  {
    text: 'News',
    path: '/',
  },
  {
    text: 'Career',
    path: '/',
  },
  {
    text: 'Downloads',
    path: '/',
  },
  {
    text: 'Online Support',
    path: '/',
  },

  {
    text: 'Feedback',
    path: '/',
  },
  {
    text: 'Legal',
    path: '/',
  },
  {
    text: 'Policy',
    path: '/policy',
  },
];
